export const mapBransjeTre = (
  bransjeTre: any[],
  selected: any[],
  canSelectNedlagt?: boolean,
  expandedIds?: Set<number>,
  facetCounts?: Map<number, number>,
  hideEmptyFacets?: boolean,
) => {
  if (!bransjeTre) return [];
  const mapped = bransjeTre.map((o) =>
    mapNode(o, selected, canSelectNedlagt, expandedIds, facetCounts),
  );
  if (!facetCounts || !hideEmptyFacets) return mapped;
  return mapped.filter((node) => keepNodeWithFacets(node, facetCounts));
};

// Skjul noder uten treff (fasett-count 0) med mindre de er valgt eller har et barn som skal beholdes.
const keepNodeWithFacets = (node: any, facetCounts: Map<number, number>): boolean => {
  node.children = (node.children || []).filter((child: any) =>
    keepNodeWithFacets(child, facetCounts),
  );
  const count = facetCounts.get(node.id) ?? 0;
  return count > 0 || node.checked || node.children.length > 0;
};

const mapNode = (
  node: any,
  selected: any[],
  canSelectNedlagt?: boolean,
  expandedIds?: Set<number>,
  facetCounts?: Map<number, number>,
) => {
  let label = node.tilOgMedDato ? node.name + '  (nedlagt)' : node.name;
  if (facetCounts) {
    const count = facetCounts.get(node.id) ?? 0;
    label = `${label} (${count.toLocaleString('nb-NO')})`;
  }

  const item = {
    label,
    navn: node.name,
    id: node.id,
    children: [],
    checked: false,
    expanded: expandedIds ? expandedIds.has(node.id) : false,
    disabled: node.tilOgMedDato && !canSelectNedlagt ? true : false,
  };

  if (selected.indexOf(node.id) > -1) {
    item.checked = true;
  }

  if (node.children) {
    node.children.forEach((element: any) => {
      item.children.push(mapNode(element, selected, canSelectNedlagt, expandedIds, facetCounts));
    });
  }
  return item;
};
